import "./datatable.scss";
import { DataGrid } from "@mui/x-data-grid";
import { userColumns, userRows } from "../../datatablesource";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { collection, getDocs, doc, setDoc, deleteDoc, updateDoc  } from "firebase/firestore";
import {db} from "../../firebase"

const Datatable = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async ()=>{
      let list = [];
      try{
        const querySnapshot = await getDocs(collection(db, "users"));
        querySnapshot.forEach((doc) => {
          list.push({id: doc.id, ...doc.data()})
        });
        setData(list)
        console.log(list)
      }catch(err){
        console.log(err)
      }
      
    }
    fetchData()
  }, [])

  console.log(data)
  

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "users", id));
      setData(data.filter((item) => item.id !== id));
    } catch (err) {
      console.log(err)
    }    
  };

  // const handleEdit = async (id)=>{
  //   try {
  //     await setDoc(doc(db, "rooms", id), {
        
  //     });
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }

  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      width: 370,
      renderCell: (params) => {
        return (
          <div className="cellAction">
            {/* <Link to="/users/test" style={{ textDecoration: "none" }}>
              <div className="viewButton">More Details</div>
            </Link> */}
            {/* <div
              className="editButton"
              onClick={() => handleEdit(params.row.id)}
            >
              Edit
            </div> */}
            <div
              className="deleteButton"
              onClick={() => handleDelete(params.row.id)}
            >
              Delete
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="datatable">
      <div className="datatableTitle">
        Users
        <Link to="/users/new" className="link">
          Add New Users
        </Link>
      </div>
      <DataGrid
        className="datagrid"
        rows={data}
        columns={userColumns.concat(actionColumn)}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection
      />
    </div>
  );
};

export default Datatable;
